// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'

type LogoProps = {
    src: ?string
}
const ImageContainer: ReactComponentStyled<{}> = styled.img`
  width: auto;
  height: 125px;
`
ImageContainer.displayName = 'ImageContainer'
class Logo extends Component<LogoProps, {}> {
  render () {
    const { src } = this.props
    return src ? <ImageContainer src={src} /> : null
  }
}

export default Logo
